export class RequestClaimDevice {
    requestId: number;
    requestDeviceId: number;
    deviceModelId: number;
    deviceModelName: string;
    marketPlaceId: number;
    marketPlaceName: string;
    manufactureDate: Date;
    serialNumber: string;
    claimedDeviceQuantity: number;
}